export default function StrategyDetailSkeleton() {
  return (
    <div className="flex flex-col gap-6 animate-pulse px-6">
      {/* Title */}
      <div className="flex flex-col items-center gap-2">
        <div className="h-8 bg-[#C7EDEF] rounded w-3/4" />
        <div className="h-5 bg-[#C7EDEF] rounded w-1/2" />
      </div>
      {/* Image placeholder */}
      <div className="w-full aspect-[382/272] bg-[#C7EDEF] rounded-lg" />
      {/* Read aloud label */}
      <div className="h-4 bg-[#C7EDEF] rounded w-24" />
      {/* Description lines */}
      <div className="flex flex-col gap-2">
        <div className="h-4 bg-[#C7EDEF] rounded w-full" />
        <div className="h-4 bg-[#C7EDEF] rounded w-full" />
        <div className="h-4 bg-[#C7EDEF] rounded w-5/6" />
        <div className="h-4 bg-[#C7EDEF] rounded w-4/6" />
      </div>
      {/* Tip box */}
      <div className="h-24 bg-[#C7EDEF] rounded-lg" />
    </div>
  );
}
